import { useEffect, useState } from "react";
// import {
//   changeDateLastWeekChart,
//   getHeartStatsLastWeek,
// } from "reducers/heartDataReducer";
import {
  changeDateperHourInDay,
  getHeartStatsLasTwoMonthsPerHour,
} from "redux/reducers/heartDataReducer";
import LineChartDateCalendarSelect from "components/Charts/LineChartDateCalendarSelect";
import { Dashboard } from "locale/es";
import { useDispatch, useSelector } from "react-redux";

const PerHourTotalInDay = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const patientId = useSelector(({ patient }) => patient.id);
  const { data, status } = useSelector(
    ({ heartData }) => heartData.lastTwoMonthsPerHourInDayPatientData
  );
  const chartData = useSelector(
    ({ heartData }) => heartData.perHourChartMinAndMaxFrequencyInDay
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (patientId && selectedDate) {
      dispatch(getHeartStatsLasTwoMonthsPerHour(patientId, selectedDate));
    }
  }, [patientId, selectedDate, dispatch]);

  useEffect(() => {
    if (patientId && !!selectedDate && !!status) {
      dispatch(changeDateperHourInDay(selectedDate.toISOString()));
    }
  }, [data, dispatch, patientId, selectedDate, status]);

  return (
    <LineChartDateCalendarSelect
      dataToShow={chartData}
      title={Dashboard.HEART_MIN_MAX_HOUR}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      minDate={null}
      maxDate={new Date()}
    />
  );
};

export default PerHourTotalInDay;
